import { S as Swiper } from './swiper-core-RAYWN467.js';
import { N as Navigation } from './navigation-fifw5zxZ.js';
import { T as Thumb, P as Pagination } from './thumbs-CaN_pc1q.js';
import { O as Oe } from './index.esm-CXYreJ4v.js';
import './classes-to-selector-M_EnDm_N.js';

class ProductMediaSwiper extends HTMLElement {
  swiper = null;
  thumbSwiper = null;
  slides = [...this.querySelectorAll('.swiper-slide')];

  connectedCallback() {
    this.initThumbSwiper();
    this.initSwiper();
    this.initFancybox();

    const videoSlidesExist = this.slides.some((slide) => slide.querySelector('video'));
    if (videoSlidesExist && this.swiper instanceof Swiper) {
      this.handleVideoPlay();
      this.swiper.on('slideChange', this.handleVideoPlay.bind(this));
    }
  }

  initSwiper() {
    this.swiper = new Swiper('.swiper--media', {
      modules: [Thumb, Navigation, Pagination],
      spaceBetween: 0,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: false,
        spaceBetween: 5,
      },
      thumbs: {
        swiper: this.thumbSwiper,
      },
    });
  }

  initThumbSwiper() {
    this.thumbSwiper = new Swiper('.swiper--thumbs', {
      spaceBetween: 8,
      slidesPerView: 'auto',
      watchSlidesProgress: true,
      breakpoints: {
        1280: {
          direction: 'vertical',
          spaceBetween: 16,
        },
      },
    });
  }

  initFancybox() {
    Oe.bind('[data-fancybox]', {
      Carousel: {
        Panzoom: {
          touch: (panzoom, event) => event?.target.nodeName !== 'MODEL-VIEWER',
        },
      },
    });
  }

  handleVideoPlay() {
    const currentSlide = this.slides[this.swiper.activeIndex || 0];
    this.slides
      .filter((slide) => slide.querySelector('video') && slide !== currentSlide)
      .forEach((slide) => slide.querySelector('video').pause());
    currentSlide?.querySelector('video')?.play();
  }
}

customElements.define('product-media-swiper', ProductMediaSwiper);
